import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type AbilitiesService from 'ember-can/services/abilities';

export default class WorkplaceApprovalsRoute extends Route {
  title = 'Workplace · Approvals · Envoy';

  @service declare abilities: AbilitiesService;
  @service declare router: RouterService;

  beforeModel(): void {
    if (this.abilities.cannot('visit approvals for workplace')) {
      this.router.transitionTo('unauthorized');
    }
  }
}
